import requests from "./httpService";

const VideoServices = {

    getVideo: async () => {
        return requests.get(`/videos`);
    },
    getVideoById: async (id) => {
        return requests.get(`/videos/${id}`);
    },
    createVideo: async (body) => {
        return requests.post(`/videos`, body);
    },
    updateVideo: async (id, body) => {
        return requests.put(`/videos/${id}`, body);
    },
    deleteVideo: async (id) => {
        return requests.delete(`/videos/${id}`);
    },
}

export default VideoServices;
